var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgClose = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 23.295 23.295"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.3,7.346,25.949,5l-9.3,9.3L7.346,5,5,7.346l9.3,9.3L5,25.949,7.346,28.3l9.3-9.3,9.3,9.3,2.346-2.346-9.3-9.3Z",
  transform: "translate(-5 -5)"
})));
export default SvgClose;